/* eslint-disable max-len */
import React from 'react';

const CBGAIcon = (props) => (
  <svg width='57' height='31' viewBox='0 0 57 31' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
    <path
      d='M23.283 10.3914C24.5269 10.3914 25.4367 9.50017 25.4367 8.25623C25.4367 7.01228 24.5269 6.12109 23.283 6.12109C22.0329 6.12109 21.1231 7.01228 21.1231 8.25623C21.1231 9.50017 22.0329 10.3914 23.283 10.3914ZM23.283 9.61157C22.5156 9.61157 22.0267 9.02364 22.0267 8.25623C22.0267 7.48263 22.5156 6.90088 23.283 6.90088C24.0442 6.90088 24.5331 7.48263 24.5331 8.25623C24.5331 9.02364 24.0442 9.61157 23.283 9.61157Z'
      fill='#4F5D68'
    />
    <path
      d='M29.7667 10.3171V6.18917H28.8817V7.81063H26.9322V6.18917H26.0534V10.3171H26.9322V8.57804H28.8817V10.3171H29.7667Z'
      fill='#4F5D68'
    />
    <path
      d='M10.8552 30.1737V26.2061H10.0046V27.7645H8.13081V26.2061H7.28613V30.1737H8.13081V28.5021H10.0046V30.1737H10.8552Z'
      fill='#4F5D68'
    />
    <path
      d='M13.5227 30.245C14.7184 30.245 15.5928 29.3885 15.5928 28.1928C15.5928 26.9972 14.7184 26.1406 13.5227 26.1406C12.3211 26.1406 11.4467 26.9972 11.4467 28.1928C11.4467 29.3885 12.3211 30.245 13.5227 30.245ZM13.5227 29.4955C12.7851 29.4955 12.3152 28.9304 12.3152 28.1928C12.3152 27.4493 12.7851 26.8901 13.5227 26.8901C14.2544 26.8901 14.7243 27.4493 14.7243 28.1928C14.7243 28.9304 14.2544 29.4955 13.5227 29.4955Z'
      fill='#4F5D68'
    />
    <path
      d='M35.1212 18.5164C36.0247 18.5164 36.5508 18.0151 36.8417 17.5014L36.0866 17.1363C35.9133 17.4705 35.542 17.7366 35.1212 17.7366C34.3661 17.7366 33.8215 17.161 33.8215 16.3812C33.8215 15.6014 34.3661 15.0259 35.1212 15.0259C35.542 15.0259 35.9133 15.292 36.0866 15.6262L36.8417 15.2549C36.5508 14.735 36.0247 14.2461 35.1212 14.2461C33.8772 14.2461 32.918 15.1063 32.918 16.3812C32.918 17.6499 33.8772 18.5164 35.1212 18.5164Z'
      fill='#4F5D68'
    />
    <path
      d='M39.3266 18.5164C40.5706 18.5164 41.4803 17.6252 41.4803 16.3812C41.4803 15.1373 40.5706 14.2461 39.3266 14.2461C38.0765 14.2461 37.1667 15.1373 37.1667 16.3812C37.1667 17.6252 38.0765 18.5164 39.3266 18.5164ZM39.3266 17.7366C38.5592 17.7366 38.0703 17.1486 38.0703 16.3812C38.0703 15.6076 38.5592 15.0259 39.3266 15.0259C40.0878 15.0259 40.5767 15.6076 40.5767 16.3812C40.5767 17.1486 40.0878 17.7366 39.3266 17.7366Z'
      fill='#4F5D68'
    />
    <path
      d='M44.0589 18.5164C45.3028 18.5164 46.2125 17.6252 46.2125 16.3812C46.2125 15.1373 45.3028 14.2461 44.0589 14.2461C42.8087 14.2461 41.899 15.1373 41.899 16.3812C41.899 17.6252 42.8087 18.5164 44.0589 18.5164ZM44.0589 17.7366C43.2914 17.7366 42.8025 17.1486 42.8025 16.3812C42.8025 15.6076 43.2914 15.0259 44.0589 15.0259C44.8201 15.0259 45.309 15.6076 45.309 16.3812C45.309 17.1486 44.8201 17.7366 44.0589 17.7366Z'
      fill='#4F5D68'
    />
    <path
      d='M50.5425 18.4421V14.3142H49.6575V15.9356H47.7081V14.3142H46.8293V18.4421H47.7081V16.703H49.6575V18.4421H50.5425Z'
      fill='#4F5D68'
    />
    <path
      d='M4.0957 29.4961L6.8457 24.2461M6.8457 24.2461V18.1211L1.2207 14.7461V8.74609L6.8457 5.24609M6.8457 24.2461H1.2207M6.8457 5.24609L11.7207 8.74609V14.7461L17.4707 18.1211M6.8457 5.24609V0.621094M17.4707 18.1211L23.0957 14.7461M17.4707 18.1211V24.2461M23.0957 14.7461L28.3457 18.1211M23.0957 14.7461V11.3711M28.3457 18.1211V24.2461M28.3457 18.1211L31.5957 16.3711M28.3457 24.2461L33.8457 27.6211L39.5957 24.2461L44.5957 27.6211L50.5957 24.2461L55.9707 27.6211M28.3457 24.2461L23.0957 27.6211L17.4707 24.2461M17.4707 24.2461L14.9707 25.9961'
      stroke='#64737F'
      strokeWidth='2'
    />
  </svg>
);
export default CBGAIcon;
